import { useEffect } from 'react';

/**
 * Hook to manage the editor's read-only state.
 *
 * Updates the TipTap editor's editable state when the readOnly prop changes.
 *
 * @param editor - TipTap editor instance
 * @param readOnly - Whether the editor should be read-only
 *
 * @example
 * ```tsx
 * useEditorReadOnly(editor, readOnly);
 * ```
 */
export function useEditorReadOnly(editor: any, readOnly: boolean) {
	useEffect(() => {
		if (!editor) return;

		editor.setEditable(!readOnly);
	}, [editor, readOnly]);
}
